// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"273":"9c3cb919","370":"312a5617","459":"c0fcaecf","862":"2b4c9fc6","888":"7b1aa472"}[chunkId] + ".chunk.js";
};